// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"cb1d61ace065ca374cf8","655":"d42048376974cd6d5642"}[chunkId] + ".js";
};